<div class="wrapper " *ngIf="global.IsLogin">

       <app-top-toolbar ></app-top-toolbar> 

    
    <div class="page-wrap">
            <app-start-sidebar >
               
            </app-start-sidebar>
        <div class="main-content">
             <div class="loading-indicator" *ngIf="global.spinner">
                <mat-progress-spinner mode="indeterminate" ></mat-progress-spinner>
              </div>  
              <div class="container-fluid">
                <!--Search mobile-->
              <!--   <div class=" d-sm-none">
                  <div class="input-group">
             

                    <div class="dropdown search">
                      <a class="dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown">
                        <span style="font-size: 14px">  Choose Clinic    </span> 
                        <i class="ik ik-chevron-down"></i> </a>
                      <div class="dropdown-menu dropdown-menu-right se" aria-labelledby="userDropdown">
                          <a class="dropdown-item" href=""><i class="ik ik-heart dropdown-icon"></i> Dentist</a> 
                          <a class="dropdown-item" href=""><i class="ik ik-heart dropdown-icon"></i> Pediatrics</a>
                           
                        </div>
                  </div>
      
                    <input type="text" class="form-control" placeholder="Search By Doctor Name">
      
                    <div class="input-group-append">
                      <button class="btn btn-search" type="button"><i class="ik ik-search"></i></button>
                    </div>
      
                  </div>
                </div> 
            -->
            
            <app-alerts></app-alerts>
            
                <router-outlet></router-outlet>
       <!-- <router-outlet name="Instructor" *ngIf="global.Role == 'Instructor'"></router-outlet>
          <router-outlet name="coordinator" *ngIf="global.Role == 'Coordinator'"></router-outlet>
        -->
        </div>
        </div>

       <app-footer ></app-footer>
        
    </div>
</div>
